import React from 'react';

import { Progress } from '@/components/ui/progressbar';

interface FreeShippingEarnedProps {
    freeShippingThresholdNumber: number;
    delayedPercentage: number;
    hideBar: boolean;
}

const FreeShippingEarned: React.FC<FreeShippingEarnedProps> = ({
    freeShippingThresholdNumber,
    delayedPercentage: delayedPercentage1,
    hideBar,
}) => (
    <>
        {!hideBar ? (
            <>
                <div className="mt-2.5 h-5 text-center text-xs leading-5">
                    You&apos;ve earned <b>FREE standard shipping!</b>
                </div>
                <div className="mb-2.5 grid h-9 grid-cols-[auto_1fr_auto] gap-2">
                    <div className="flex items-center justify-center">$0</div>
                    <div className="flex items-center justify-center">
                        <Progress value={delayedPercentage1} />
                    </div>
                    <div className="flex items-center justify-center">${freeShippingThresholdNumber}</div>
                </div>
            </>
        ) : (
            <>
                <div className="mb-2.5 mt-2.5 h-9 text-center text-xs leading-4">
                    You&apos;ve earned <b>FREE standard shipping</b> with{' '}
                    <b className="whitespace-nowrap">Rogers Bank Mastercard!</b>
                </div>
            </>
        )}
    </>
);

export default FreeShippingEarned;
